import React, { useCallback, useEffect, useState } from "react";
import "../ModalMouqabale.styles.scss";
import {
  fakeCreneauList,
  TCreneau,
  TCreneauDay,
  TCreneauStep,
  TCurrentExchange,
  TMiniProfil,
  TMouqabalaStep,
} from "@/features/profile/types";
import { Button, Checkbox } from "@mui/material";
import { InlineIcon } from "@iconify/react";
import {
  apiGetCreneauMouqabala,
  apiSendCreneauMouqabala,
} from "@/features/profile/api/mouqabala.api";
import { Toastify } from "@/utils/toast";
import LoaderMini from "@/components/Loader-mini/LoaderMini";
import * as moment from "moment";
import "moment/locale/fr";
import { useSelector } from "react-redux";
import {
  selectMemberProfile,
  selectUserConnected,
} from "@/store/reducers/member/member.selector";
import NoData from "@/components/No-data/NoData";
import { TMemberProfile } from "@/features/auth/types";

interface MouqStep3Props {
  setStep: React.Dispatch<React.SetStateAction<TMouqabalaStep | TCreneauStep>>;
  close?: () => void;
  receiver: TMiniProfil | null;
  setSelectedCreneau: React.Dispatch<React.SetStateAction<Partial<TCreneau>>>;
  conversation_id: string;
  isFromModalCreneau?: boolean;
}
const MouqStep3 = ({
  setStep,
  close,
  receiver,
  setSelectedCreneau,
  conversation_id,
  isFromModalCreneau = false,
}: MouqStep3Props) => {
  const [creneauDayList, setCreneauDayList] = useState<TCreneauDay[]>([]);
  const [creneauList, setCreneauList] = useState<TCreneau[]>([]);
  const [loadingCreneau, setLoadingCreneau] = useState(false);
  const [loadingReservation, setLoadingReservation] = useState(false);
  const userConnected = useSelector(selectMemberProfile) as TMemberProfile;

  const handleChange = (id: number) => {
    let tempCreneauList = [...creneauList].map((x) => ({
      ...x,
      isSelected: x.id_creneau === id,
    }));

    setSelectedCreneau({
      ...tempCreneauList.find((x) => x.isSelected === true),
    });

    console.log({
      ...tempCreneauList.find((x) => x.isSelected === true),
    });

    setCreneauList([...tempCreneauList]);
  };

  const initializeCreneauDay = () => {
    let tempCreneauDayList: TCreneauDay[] = [
      {
        creneau_day: "Lundi",
        creneau_day_date: "01/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Mardi",
        creneau_day_date: "02/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Mercredi",
        creneau_day_date: "03/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Jeudi",
        creneau_day_date: "04/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Vendredi",
        creneau_day_date: "05/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Samedi",
        creneau_day_date: "06/01/2024",
        isSelected: false,
      },
      {
        creneau_day: "Dimanche",
        creneau_day_date: "07/01/2024",
        isSelected: false,
      },
    ].map((x, index) => {
      moment.default(new Date()).format("L");
      return {
        creneau_day: moment.default(new Date()).add(index, "d").format("dddd"),
        creneau_day_date: moment
          .default(new Date())
          .add(index, "d")
          .format("L"),
        isSelected: index === 0,
      };
    });
    setCreneauDayList([...tempCreneauDayList]);
  };

  const getCreneau = useCallback(
    (indexDay: number) => {
      if (creneauDayList.length !== 0) {
        const selectedDayDate =
          creneauDayList[indexDay]?.creneau_day_date || "";

        const tempCreneauDayList = creneauDayList.map((x, index) => ({
          ...x,
          isSelected: index === indexDay,
        }));
        setCreneauDayList([...tempCreneauDayList]);

        setLoadingCreneau(true);
        apiGetCreneauMouqabala({
          selected_date: selectedDayDate,
        })
          .then((response: any) => {
            setLoadingCreneau(false);
            console.log(response);
            const data = response.data;

            const tempCreneauList: TCreneau[] = data.map((x: any) => ({
              id_creneau: x.id || "",
              creneau_date: moment.default(x.startTime).format("L"),
              creneau_start_time:
                moment.default(x.startTime).format("HH:mm") || "",
              creneau_end_time: moment.default(x.endTime).format("HH:mm") || "",
              creneau_duration: x.muqabalaPrice.durationMinutes + " min" || "",
              creneau_tarif:
                userConnected?.infos.identity.gender === "MALE"
                  ? x.muqabalaPrice.priceForMen + "€" || ""
                  : x.muqabalaPrice.priceForWomen + "€" || "",
              isSelected: false,
            }));
            setCreneauList([...tempCreneauList]);
          })
          .catch((error) => {
            setLoadingCreneau(false);
            Toastify(`${error?.response?.data?.message}`, "error", 5000);

            setCreneauList([...fakeCreneauList]); //<----- juste pour les test à enlever après
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [creneauDayList, creneauList]
  );

  const initializeCreneau = () => {
    setLoadingCreneau(true);
    apiGetCreneauMouqabala({
      selected_date: moment.default(new Date()).format("L"),
    })
      .then((response: any) => {
        setLoadingCreneau(false);
        console.log(response);
        const data = response.data;

        const tempCreneauList: TCreneau[] = data.map((x: any) => ({
          id_creneau: x.id || "",
          creneau_date: moment.default(new Date()).format("L"),
          creneau_start_time: moment.default(x.startTime).format("HH:mm") || "",
          creneau_end_time: moment.default(x.endTime).format("HH:mm") || "",
          creneau_duration: x.muqabalaPrice.durationMinutes + " min" || "",
          creneau_tarif:
            userConnected?.infos.identity.gender === "MALE"
              ? x.muqabalaPrice.priceForMen + "€" || ""
              : x.muqabalaPrice.priceForWomen + "€" || "",
          isSelected: false,
        }));
        setCreneauList([...tempCreneauList]);
      })
      .catch((error) => {
        setLoadingCreneau(false);
        Toastify(`${error?.response?.data?.message}`, "error", 5000);
      });
  };

  useEffect(() => {
    initializeCreneauDay();
    initializeCreneau();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reserverMouqabala = () => {
    setLoadingReservation(true);
    apiSendCreneauMouqabala({
      id_creneau:
        creneauList.find((x) => x.isSelected === true)?.id_creneau || "",
    })
      .then((response: any) => {
        setLoadingReservation(false);
        console.log(response);
        isFromModalCreneau && setStep(2);
        !isFromModalCreneau && setStep(4);
      })
      .catch((error) => {
        setLoadingReservation(false);
        Toastify(`${error?.response?.data?.message}`, "error", 5000);
      });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <div className="creneau-part">
        <div className="creneau-title">
          <span> Choisissez un créneau pour la Mouqabala :</span>
        </div>
        {loadingReservation ? (
          <LoaderMini />
        ) : (
          <>
            <div className="creneau-day-part">
              {creneauDayList.map((elt, index) => (
                <div
                  key={index}
                  id={"id-day-" + index}
                  className={`creneau-day-item ${
                    elt.isSelected ? "active" : ""
                  }`}
                  onClick={() => {
                    getCreneau(index);
                  }}
                >
                  <p>{elt.creneau_day}</p>
                  <small>{elt.creneau_day_date}</small>
                </div>
              ))}
            </div>
            {loadingCreneau ? (
              <LoaderMini />
            ) : (
              <>
                {creneauList.length === 0 ? (
                  <NoData />
                ) : (
                  <>
                    {creneauList.map((elt, index) => (
                      <div
                        key={index}
                        className={`creneau-item ${
                          elt.isSelected ? "selected" : ""
                        }`}
                        onClick={() => {
                          handleChange(elt.id_creneau);
                        }}
                      >
                        <Checkbox
                          color="secondary"
                          checked={elt.isSelected}
                          onChange={() => {
                            handleChange(elt.id_creneau);
                          }}
                          className="scale-150"
                          icon={
                            <InlineIcon
                              icon="line-md:confirm-circle-to-circle-transition"
                              color="var(--ui-gray)"
                            />
                          }
                          checkedIcon={
                            <InlineIcon
                              icon="line-md:confirm-circle-twotone"
                              color="var(--ui-primary)"
                            />
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        <p>
                          <b style={{ textTransform: "capitalize" }}>
                            {moment
                              .default(
                                new Date(
                                  parseInt(
                                    creneauDayList
                                      .find((x) => x.isSelected === true)
                                      ?.creneau_day_date.split("/")[2] || "0"
                                  ),

                                  parseInt(
                                    creneauDayList
                                      .find((x) => x.isSelected === true)
                                      ?.creneau_day_date.split("/")[1] || "0"
                                  ) - 1,

                                  parseInt(
                                    creneauDayList
                                      .find((x) => x.isSelected === true)
                                      ?.creneau_day_date.split("/")[0] || "0"
                                  )
                                )
                              )
                              .format("dddd,  Do MMMM YYYY ")}
                          </b>{" "}
                          • De <b>{elt.creneau_start_time}</b> à{" "}
                          <b>{elt.creneau_end_time}</b> ({elt.creneau_duration})
                          •{" "}
                          <b style={{ color: "var(--ui-tertiary-shade)" }}>
                            {elt.creneau_tarif}
                          </b>
                        </p>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
      <div className="btn-layout">
        <Button
          variant="outlined"
          className="btn-mouq"
          onClick={() => {
            close!();
          }}
          color="tertiary"
        >
          Annuler et retour à la discussion
        </Button>
        <Button
          variant="contained"
          className="btn-mouq"
          disabled={creneauList.findIndex((x) => x.isSelected === true) === -1}
          onClick={reserverMouqabala}
          endIcon={<InlineIcon icon="ic:outline-navigate-next" />}
          color="primary"
        >
          réserver
        </Button>
      </div>
    </div>
  );
};

export default MouqStep3;
